class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
    this.cartModal = document.querySelector('cart-modal');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);

    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const config = fetchConfig('javascript');
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);

    if (this.form.dataset.bundle === 'true') {
      const currentQuantity = parseInt(
        document.querySelector('input[name="quantity"]').value
      );
      const freeQuantity =
        currentQuantity > 0 ? Math.floor(currentQuantity / 5) : 0;

      formData.set('quantity', currentQuantity + freeQuantity);
    }

    formData.append(
      'sections',
      this.cartNotification.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartNotification.renderContents(parsedState);
        this.cartModal?.show(submitButton);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}

customElements.define('product-form', ProductForm);
